import cstMetadata from './data/metadata.json';
import type { CstDataVersion } from './types.js';

export const CST_DATA_VERSION: CstDataVersion = cstMetadata as CstDataVersion;
